import { Directive, ElementRef, inject, input } from '@angular/core';

import { TooltipDirective } from './tooltip.directive';

const DISABLED_CLASS = 'overflow-disabled';

@Directive({
  host: {
    class: 'ideals-overflow',
    '(mouseover)': 'checkOverflow()',
  },
  selector: '[idealsOverflow]',
})
export class TooltipOverflowDirective {
  readonly skipOverflowCheck = input(false);

  readonly #element = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
  readonly #tooltip = inject(TooltipDirective, { optional: true, self: true });

  // `mouseover` fires before `mouseenter`, so the tooltip sees the fresh state when it decides whether to show.
  checkOverflow(): void {
    if (!this.#tooltip) {
      return;
    }

    const disabled = this.#element.classList.contains(DISABLED_CLASS);
    const fits = this.#element.scrollWidth <= this.#element.clientWidth;

    this.#tooltip.setOverflowDisabled(disabled || !this.skipOverflowCheck() && fits);
  }
}
